import API from '~config/api';
import { ApiPromise, DataResponse, ErrorResponse } from '~globals/types';

import {
  AdminBillingListBillingBase,
  AdminBillingListBillingIds,
  AdminBillingListBillingCreateBody,
  AdminBillingListBillingUpadateBody,
} from './types';

export const BILLING_LIST_BILLING_ENDPOINTS = {
  getAdmingBillingListBillings: (billingListId: string): string =>
    `/api/v1/Route/BillingList/${billingListId}/Billing`,
  getAdmingBillingListBillingById: ({
    billingListId,
    billingId,
  }: AdminBillingListBillingIds): string =>
    `/api/v1/Route/BillingList/${billingListId}/Billing/${billingId}`,
  createAdmingBillingListBilling: '/api/v1/Route/Billing',
  updateAdmingBillingListBilling: '/api/v1/Route/Billing',
  deleteAdmingBillingListBilling: ({
    billingListId,
    billingId,
  }: AdminBillingListBillingIds): string =>
    `/api/v1/Route/BillingList/${billingListId}/Billing/${billingId}`,
};

export const getAdmingBillingListBillings = (
  billingListId: string,
): ApiPromise<DataResponse<AdminBillingListBillingBase[]>, ErrorResponse> =>
  API.get<DataResponse<AdminBillingListBillingBase[]>, ErrorResponse>(
    BILLING_LIST_BILLING_ENDPOINTS.getAdmingBillingListBillings(billingListId),
  );

export const getAdmingBillingListBillingById = ({
  billingListId,
  billingId,
}: AdminBillingListBillingIds): ApiPromise<
  DataResponse<AdminBillingListBillingBase>,
  ErrorResponse
> =>
  API.get<DataResponse<AdminBillingListBillingBase>, ErrorResponse>(
    BILLING_LIST_BILLING_ENDPOINTS.getAdmingBillingListBillingById({
      billingListId,
      billingId,
    }),
  );

export const createAdmingBillingListBilling = (
  body: AdminBillingListBillingCreateBody,
): ApiPromise<DataResponse<AdminBillingListBillingBase>, ErrorResponse> =>
  API.post<DataResponse<AdminBillingListBillingBase>, ErrorResponse>(
    BILLING_LIST_BILLING_ENDPOINTS.createAdmingBillingListBilling,
    body,
  );

export const updateAdmingBillingListBilling = (
  body: AdminBillingListBillingUpadateBody,
): ApiPromise<DataResponse<AdminBillingListBillingBase>, ErrorResponse> =>
  API.put<DataResponse<AdminBillingListBillingBase>, ErrorResponse>(
    BILLING_LIST_BILLING_ENDPOINTS.updateAdmingBillingListBilling,
    body,
  );

export const deleteAdmingBillingListBilling = ({
  billingListId,
  billingId,
}: AdminBillingListBillingIds): ApiPromise<
  DataResponse<AdminBillingListBillingBase>,
  ErrorResponse
> =>
  API.delete<DataResponse<AdminBillingListBillingBase>, ErrorResponse>(
    BILLING_LIST_BILLING_ENDPOINTS.deleteAdmingBillingListBilling({
      billingListId,
      billingId,
    }),
  );
